export const SECONDS_PER_15_MINUTES = 900;
export const SECONDS_PER_HOUR = 3600;
export const SECONDS_PER_6_HOURS = 21600;
export const SECONDS_PER_DAY = 86400;
export const SECONDS_PER_WEEK = 604800;
const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const computeBucketSizeSeconds = (
  startMs: number,
  endMs: number
): number => {
  const rangeDays = (endMs - startMs) / MS_PER_DAY;
  if (rangeDays > 30) return SECONDS_PER_DAY;
  if (rangeDays > 7) return SECONDS_PER_6_HOURS;
  if (rangeDays > 1) return SECONDS_PER_HOUR;
  return SECONDS_PER_15_MINUTES;
};
